module.exports = __webpack_public_path__ + "assets/img/IMG100.47ea83e3.png";